import { hasScriptLoaded } from 'embed/utils'
import { googleMapsApiToken } from 'embed/constants/config'

const TIMEOUT = 10000
const CALLBACK_SYMBOL = '__GOOGLEMAPSCALLBACK'
const PLACES_API = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiToken}&libraries=places&callback=${CALLBACK_SYMBOL}`

export class GoogleMapsClient {
  public load: Promise<this>
  public autocomplete: google.maps.places.AutocompleteService
  public places: google.maps.places.PlacesService

  constructor() {
    this.load = new Promise<this>((resolve, reject) => {
      const timeout = setTimeout(() => {
        reject(new Error('Could not load Google Maps API'))
      }, TIMEOUT)

      window[CALLBACK_SYMBOL] = () => {
        clearTimeout(timeout)
        this.autocomplete = new google.maps.places.AutocompleteService()
        this.places = new google.maps.places.PlacesService(document.createElement('div'))
        resolve(this)
      }

      if (!hasScriptLoaded(PLACES_API)) {
        const scriptElement = document.createElement('script')
        scriptElement.src = PLACES_API
        document.body.appendChild(scriptElement)
      }
    })
  }
}

export default new GoogleMapsClient()
